import $ from "jquery";

import { setAccordian } from "#scripts/accordian.js";
import { createGallery, createCarousel } from "#scripts/create_gallery.js";
import { setImages, setImageText, getImage, setResponsiveImage, getImageByContentId } from "#scripts/images.js";
import { tableResponsive } from "#scripts/table.js";
import show404 from "#templates/pages/status_404.js";
import setModules from "#scripts/modules.js";
import getBarnehageFakta from "#scripts/get_barnehagefakta.js";
import { getApiWarnings } from "#scripts/warnings";
import {
	getRelatedBlocks,
	checkNested,
	getRelations,
	getConfig,
	setVariable,
	setLists,
	createGuid,
	adjustVariables,
	testDynData,
	getDynDataOne,
	checkDocument,
	removeExtraSpace,
	articlesExtend,
	setCorrectTemplate,
	urlRest,
	getPageUrl,
	urlify
} from "#scripts/general_functions.js";
import { getLangForApi } from "#scripts/cmsapi.js";
import { compileResources, insertSegments, checkSingleLinks } from "#scripts/compile";
import { setContactInfo, setContactArticle, ViewContactByAPI } from "#scripts/contact_functions.js";
import checkSemantics from "#scripts/check_semantics.js";
import { skjemaLink, skjemaInline } from "#scripts/skjema.js";
import articleDefault from "#templates/views/article_default";
import articleNews from "#templates/views/article_news";
import articleFocusarticle from "#templates/views/article_focusarticle.js";
import articleBtiFrontpage from "#templates/views/article_bti_frontpage.js";
import page404 from "#templates/views/page404.js";
import { articleTransportpage } from "#templates/views/article_transportpage.js";
import { articleThemepage } from "#templates/views/article_themepage.js";
import { articleUnitpage } from "#templates/views/article_unitpage.js";
import { btiStep } from "#scripts/bti.js";
import { compileModules } from "#scripts/tools/compile_content.js";
import { AimError, AimWarn } from "#scripts/tools/aimlog.js";
import language from "#scripts/translation";
import postLoadFunctions from "#scripts/postloadfunctions.js";

import dayjs from "dayjs";
import "dayjs/locale/nb"; // load on demand

// setCorrectTemplate;
dayjs.locale("nb");

export const decodeIfNeeded = (contentToDecode) => {
	let content = contentToDecode;
	// while ((contentToDecode.includes("%20") || contentToDecode.includes("%3C")) && decodeURIComponent(contentToDecode) !== contentToDecode) {
	// 	content = decodeURIComponent(contentToDecode);
	// }

	let decodingFailed = false;
	// Check if content needs to be decoded more ( has <, > or [space] decoded)
	while (!decodingFailed && content && (content.includes("%3C") || content.includes("%3E") || content.includes("%20"))) {
		try {
			content = decodeURIComponent(content);
		} catch {
			decodingFailed = true;
			while (content.includes("%20")) {
				content = content.replaceAll("%20", " ");
			}
		}
	}
	return content;
};

export default function () {
	const getArticle = () => {
		const pageUrl = getPageUrl();

		// *** Moved to startscript.js ***
		// const hasRedirect = window.clientRedirects ? window.clientRedirects.filter((r) => r.oldUrl === window.location.pathname) : undefined;
		// if (hasRedirect.length > 0) {
		// 	const redirectUrl = hasRedirect[0].newUrl;
		// 	console.log(`Redirecting from ${window.location.pathname} to ${redirectUrl}...`);

		// 	const urldivert = redirectUrl.substr(1).split(/\/(.+)/);
		// 	pageUrl.template = urldivert[0] || "frontpage";
		// 	pageUrl.contentid = urldivert[1] || "";
		// }

		const articleId = pageUrl.contentid || pageUrl.template;

		const apiCall = `${window.apiUrl}/Public/articles/${articleId}?subscriptionId=${window.serverdata.configMeta.aim.clientId}&language=${getLangForApi()}&includeCategories=true&getRecursiveContent=true`;
		const articleCall = { type: "get", url: apiCall };

		if (window.getUrlAttr("preview") === "true") {
			articleCall.url = `${window.apiUrl}/ContentApi/articles/${articleId}?subscriptionId=${window.serverdata.configMeta.aim.clientId}`;
			// articleCall.url = `${window.apiUrl}/ContentApi/find/${articleId}/preview`;
			articleCall.headers = {
				Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				subscriptionId: window.serverdata.configMeta.aim.clientId,
			};
		}

		// NOT SHURE WHY THIS CODE WAS HERE (PROBABLY CAUSE TO DIFFER ON EARLYER API FOR FIND AND FINDBYNAMEINURL)
		// if (window.dev) {
		// 	if (!articleId.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i) && window.getUrlAttr("preview") !== "true") {
		// 		if (articleId.match("/")) {
		// 			const splittedid = articleId.split("/");
		// 			articleId = splittedid[splittedid.length - 1];
		// 		}
		// 		articleCall.url = `${window.apiUrl}/PublicContentApi/findbynameinurl/${articleId}/${window.serverdata.configMeta.aim.clientId}`;
		// 		// 	${window.apiUrl}/Public/articles/${articleId}?subscriptionId=${window.serverdata.configMeta.aim.clientId}&language=${getLangForApi()}&includeCategories=true&getRecursiveContent=true
		// 		// `;
		// 	}
		// }

		let joined = "";
		let kariVarUrl = `https://config.aim.prokom.no/clients/configbackup/variables_${window.serverdata.configMeta.aim.nameId}.json`;
		let requestOptions = {
			type: "GET",
		};
		if (window.AimCookies.RuntimeMode === "qa") {
			kariVarUrl = "https://kariadminqa.azurewebsites.net/api/clientvariables";
			requestOptions = {
				type: "POST",
				headers: {
					"Content-Type": "application/json-patch+json",
				},
				data: JSON.stringify({ clientId: window.serverdata.configMeta.aim?.kariClientId }),
			};
		}
		$.when($.ajax(kariVarUrl, requestOptions))
			.fail((jqxhr, status, error) => {
				// console.error("Error", error);
				console.info("Mangler Karivars og karilinks");
				joined = {};
				AimError(`Error: ${error.toString()}`, kariVarUrl);
			})
			.done((variables) => {
				if (typeof variables === "string") {
					if (!variables.match("<title>Error - KariAdmin</title>")) {
						joined = JSON.parse("[]");
					}
				} else {
					joined = adjustVariables(variables);
				}

				if (!variables) {
					console.info("Mangler Karivars og karilinks");
					AimWarn("Missing Kari-vars and Kari-links");
				}
			})
			// if 404 do not load from api
			.always(() => {
				$.when($.ajax(articleCall))
					.fail((jqxhr, status, error) => {
						if (articleId !== "404") {
							AimError(`404 Error: ${error.toString()}`, articleCall.url.toString());
						}
						$("#contentHtml").html(show404());
					})
					.then((_article) => {
						let article = _article;
						// data = data.listOfContent;
						// if (data?.length > 0) {
						//   data.forEach((article) => {
						if (!article) {
							$("#contentHtml").html(show404());
							return;
						}
						if (article?.found === false) {
							AimError(`404 Error`, articleCall.url.toString());
							$("#contentHtml").html(show404());
							return;
						}

						if (article.metaObject) {
							if (article.metaObject !== "undefined") {
								article = articlesExtend(article);
							}

							if (article.metaParsed && article.pageTypeId === "mal_dynamisk") {
								const metaArticleTypeId = setCorrectTemplate(article.metaParsed);
								if (metaArticleTypeId) {
									article.pageTypeId = metaArticleTypeId;
								}
							}
						}

						if (article.extension !== null) {
							window.location = article.path;

							article.title = article.filename;
							// article.contentObject = `<p>
							article.contentObject = encodeURIComponent(`<p>
                        Dokumentet lastes ned automatisk. Dersom ikke nedlastningen skulle fungere, kan du klikke her: <a href="${article.path}">${article.path}</a>
                    </p>`);
						}

						const meta = article.metaObject || false;

						// window.contentID = article.contentId;
						window.contentSubscription = window.serverdata.configMeta.aim.clientId;

						// getApiWarnings();

						const config = getConfig();

						document.title = `${article.title} - ${config.name}`;

						let urlPath = "";
						urlPath = article.shortNameInUrl || article.nameInUrl || article.contentId;

						const urlrest = urlRest(window.location.href);

						if (window.getUrlAttr("preview") !== "true") {
							const newPath = urlPath + urlrest;
							if (article.pageTypeId !== "mal_blokk") {
								window.history.pushState(
									{
										path: newPath,
										pageTitle: `${article.title} - ${config.name}`,
									},
									"",
									newPath,
								);
							} else {
								window.history.pushState(
									{
										path: newPath,
										pageTitle: `${article.title} - ${config.name}`,
									},
									"",
									`/blokk/${article.contentId}`,
								);
							}
						}

						// let content = decodeURIComponent(article.contentObject) || "";
						let content = decodeIfNeeded(article.contentObject) || "";

						// let decodingFailed = false;
						// // Check if content needs to be decoded more ( has <, > or [space] decoded)
						// while (!decodingFailed && (content.includes("%3C") || content.includes("%3E") || content.includes("%20"))) {
						// 	try {
						// 		content = decodeURIComponent(content);
						// 	} catch {
						// 		decodingFailed = true;
						// 	}
						// }

						if (article.pageTypeId === "mal_visittkort") {
							const model = {
								phone: article.metaParsed.personMobil.trim(),
								wiredPhone: article.metaParsed.personTelefon.trim(),
								title: article.metaParsed.personStilling,
								department: article.metaParsed.personAvdeling,
								email: article.metaParsed.personEpost.trim(),
								name: article.metaParsed.personNavn,
								about: article.metaParsed.personFritekst,
								image: article.metaParsed.personBilde
							};

							// imageContentId:	""
							// personAvdeling:	""
							// personBilde:	""
							// personEpost:	" vei@kongsberg.kommune.no"
							// personFritekst:	"Send e-post om feil og mangler på kommunale veier"
							// personMobil:	"48 16 66 50"
							// personNavn: "Teknisk vakttelefon"
							// personStilling:	"Brøyting, strøing og vedlikehold av kommunale veier"
							// personTelefon:	""
							content = setContactArticle(model);

							if (article?.relatedContentObjects?.length < 1) {
								const newA = JSON.parse(JSON.stringify(article));
								article.relatedContentObjects = [newA];
							}
						}
						if (article.pageTypeId === "mal_dynamisk") {
							const metaData = $.parseJSON(decodeURIComponent(meta));
							if (metaData.id === "f63340c6-b3c3-49c0-b8c8-a661b55cd946") {
								const bti = btiStep([{ obj: article, meta: metaData }]);

								content = bti;

								setTimeout(() => {
									$(".bti__step").addClass("d-block");
								}, 200);
							}

							if (article?.relatedContentObjects?.length < 1) {
								const newA = JSON.parse(JSON.stringify(article));
								article.relatedContentObjects = [newA];
							}
						}

						content = setModules(content);
						content = compileResources(content, article.relatedContentObjects);

						const me = $(`<div>${content}</div>`);

						me.find(".cke_reset").remove();
						me.find('[contenteditable="true"]').removeAttr("contenteditable");

						me.find(".var_text").contents().unwrap();

						const allRelateds = [];
						const pushRelatedContentObjects = (obj) => {
							if (obj.relatedContentObjects) {
								for (const relObj of obj.relatedContentObjects) {
									allRelateds.push(relObj);
									if (relObj?.relatedContentObjects) {
										pushRelatedContentObjects(relObj);
									}
								}
							}
						};

						pushRelatedContentObjects(article);

						content = me.html();
						content = checkSingleLinks(content);
						content = removeExtraSpace(content);
						content = tableResponsive(content).innerHTML;
						content = setImages(content);
						if (joined.length > 0) {
							content = setVariable(content, joined);
						}
						// const skjemaReplaceUrl = window.serverdata.configMeta.aim.skjema.url ? window.serverdata.configMeta.aim.skjema.url : "/skjema/";
						// content = content.replace(/href="aim:skjema:/gim, `href="${skjemaReplaceUrl}`);
						content = skjemaLink(content);
						content = content.replace(/href="aim:/gim, 'href="/artikkel/');
						content = setLists(window.serverdata.configMeta.aim.clientId, content);
						content = setAccordian(content);
						content = checkSemantics(content);
						content = insertSegments(content);

						let metaData = {};
						let hasRightColumn = false;
						let rightColumn = "";
						let mainImage = "";

						if (meta !== "undefined" && meta !== "mermeta") {
							metaData = $.parseJSON(decodeURIComponent(meta));
							ViewContactByAPI(metaData, article.title, content);

							if (checkNested(metaData, "kontaktkort", "0", "kontaktkort_personnavn") && !(article.pageTypeId === "mal_enhetsmal" && content.match("APIDATA:BARNEHAGEFAKTA"))) {
								const contentToRightColumn = setContactInfo(metaData.kontaktkort, true);
								if (contentToRightColumn !== '') {
									rightColumn = contentToRightColumn;
								}
								if (rightColumn) {
									hasRightColumn = true;
								}
							}

							if (checkNested(metaData, "relasjoner", "0", "id")) {
								rightColumn += getRelations(metaData.relasjoner, "unit");

								if (rightColumn) {
									hasRightColumn = true;
								}
							}

							if (article.pageTypeId === "mal_enhetsmal" && content.match("APIDATA:BARNEHAGEFAKTA")) {
								let overrideContact = false;

								if (checkNested(metaData, "kontaktkort", "0", "kontaktkort_personnavn")) {
									overrideContact = setContactInfo(metaData.kontaktkort, false);
								}

								content = content.replace("APIDATA:BARNEHAGEFAKTA", "<div id='barnehagefakta-opinion'></div>");

								if (metaData?.enhetsId?.length > 0) {
									rightColumn += getBarnehageFakta(metaData, overrideContact);
									hasRightColumn = true;
								}
							}

							if (metaData.imageContentId !== undefined && metaData.relatedContentObjects) {
								const url = getImage(
									metaData.imageContentId,
									article.relatedContentObjects,
									"https://aimblob.blob.core.windows.net/aimfiles/daf64fb1-dc1a-4795-b1da-d2f8958a9ecd.jpg",
								);
								mainImage = `
                        <div class="article__introimage__container">
                            <img src="${url}" style="width:100%" alt="" class="article__introimage" >
                            <figcaption>${metaData.imageContentId ?? ""}</figcaption>
                        </div>`;

								// hasMainImage = true;
							} else if (metaData.imageContentId !== undefined && metaData.imageContentId.length > 0) {
								const imgId = createGuid();

								mainImage = `
                            <div class="article__introimage__container">
                                <img src="" style="width:100%;" alt="" class="article__introimage" id="${imgId}" >
                                <figcaption class="article__imgtxt__text">${metaData.imageDescription !== undefined ? metaData.imageDescription : ""}</figcaption>
                            </div>`;

								getImageByContentId(metaData.imageContentId, (img) => {
									if (img.url !== undefined && img.url.length > 0) {
										// hasMainImage = true;
										$(`#${imgId}`).attr({
											"data-src": img.url,
											src: "/images/transparent.png",
											// title: img.title,
											alt: img.alt,
											"data-imagemode": "fill",
											"data-imagehotspot": `${img.imageHotspotX},${img.imageHotspotY}`,
										});
										if (img.desc && $(".article__imgtxt__text")[0]?.innerHTML === "") {
											$(".article__imgtxt__text")[0].innerText = img.desc ?? "";
										}
										const copyright = img?.copyright?.trim();
										const textEl = document.querySelector(".article__imgtxt__text");
										if (copyright && textEl && !textEl.innerHTML) {
											textEl.innerHTML = `<p>Foto: ${copyright}</p>`;
										}
										if (img.imageHotspotX !== undefined && img.imageHotspotY !== undefined) {
											$(`#${imgId}`).attr({
												"data-imagehotspot": `${img.imageHotspotX},${img.imageHotspotY}`,
											});
										}
										setResponsiveImage($(`#${imgId}`));
									} else {
										$(".image__container").innerHTML = "";
									}
								});
							}
						}

						if (article.relatedContentObjects || article.relatedSubscriberContents) {
							const relatedContacts = getRelatedBlocks(article, "contact");

							if (relatedContacts.length > 0) {
								rightColumn += getRelations(relatedContacts, "contact");
								if (rightColumn) {
									hasRightColumn = true;
								}
							}

							const relatedBlocks = getRelatedBlocks(article, "block");

							if (relatedBlocks.length > 0) {
								getRelations(relatedBlocks, "block");
							}

							const relatedUnits = getRelatedBlocks(article, "unit");
							if (relatedUnits.length > 0) {
								rightColumn += getRelations(relatedUnits, "unit");
								if (rightColumn) {
									hasRightColumn = true;
								}
							}
						}

						let dynIntro = false;

						if (testDynData(metaData, "localId", "a8d20515-d33f-48dd-a053-9eea026f7919")) {
							dynIntro = getDynDataOne(metaData, "a8d20515-d33f-48dd-a053-9eea026f7919", "localId").value; // Forsidetekst.
						}

						const intro = article.intro || dynIntro || "";

						$("#currentPageBreadcrumb").text(article.title);
						const shortNewsBreadcrumb = window.serverdata.configMeta.aim?.showShortNewsBreadcrumb ?? true;
						if (article.pageTypeId === "mal_nyhet" && shortNewsBreadcrumb) {
							const currentBreadcrumb = document.getElementById("currentPageBreadcrumb");
							const breadcrumbItem = document.createElement("li");
							breadcrumbItem.classList.add("aim-breadcrumb-item");
							const breadcrumbItemLink = document.createElement("a");
							breadcrumbItemLink.href = "/liste/nyheter";
							breadcrumbItemLink.innerText = language("NEWS_NEWS");
							breadcrumbItem.appendChild(breadcrumbItemLink);
							if (currentBreadcrumb) {
								currentBreadcrumb.parentNode.insertBefore(breadcrumbItem, currentBreadcrumb);
								// currentBreadcrumb.innerText = document.title;
							}
						}

						const title = article.title || "";
						const imageSpan = "col-md-10 col-lg-7";

						content = checkDocument(content, allRelateds);

						// Remove empty headers (e.g. <h2>&nbsp;</h2>)
						content = content.replace(/<h\d>&nbsp;<\/h\d>/gim, "<p>&nbsp;</p>");

						const minNofHeadings = Number.parseInt(window.serverdata.configMeta.aim.articleTocMinHeadings);
						if (minNofHeadings > 0 && (article.pageTypeId === "mal_enhetsmal" || article.pageTypeId === "mal_artikkel")) {
							let toc = "";
							// const minNofHeadings = 2;
							const minLevel = 2;
							const maxLevel = 2;
							const contentDom = new DOMParser().parseFromString(content, "text/html");
							const pageHeaders = contentDom.querySelectorAll(
								`
              h1:not(.accordian h1):not(.bti__level__button h1):not(.bti__button h1):not(.bti__step__content h1), 
              h2:not(.accordian h2):not(.bti__level__button h2):not(.bti__button h2):not(.bti__step__content h2), 
              h3:not(.accordian h3):not(.bti__level__button h3):not(.bti__button h3):not(.bti__step__content h3) ,
              h4:not(.accordian h4):not(.bti__level__button h4):not(.bti__button h4):not(.bti__step__content h4), 
              h5:not(.accordian h5):not(.bti__level__button h5):not(.bti__button h5):not(.bti__step__content h5), 
              h6:not(.accordian h6):not(.bti__level__button h6):not(.bti__button h6):not(.bti__step__content h6)`,
							);

							for (const h of pageHeaders) {
								if (h.innerHTML !== "&nbsp;" && h.tagName.substr(1, 1) >= minLevel && h.tagName.substr(1, 1) <= maxLevel) {
									const titleText = h.innerText.trim();
									const anchor = urlify(titleText);
									toc += `<li><a class="toc__link" href="#${anchor}">${titleText}</a></li>`;
									h.id = anchor;
								}
							}
							content = contentDom.body.innerHTML;
							if (toc !== "" && toc.match(/<li>/g).length >= minNofHeadings) {
								content = `<ul class='article__toc'>${toc}</ul>${content}`;
							}
						}

						let created = dayjs(article.firstCreated).format("DD.MM.YYYY");
						let published = dayjs(article.published !== null ? article.published : article.firstCreated).format("DD.MM.YYYY");
						if (article?.lastRelatedContentPublished !== null && article?.lastRelatedContentPublished !== undefined) {
							if (article.lastRelatedContentPublished.published > article.published) {
								var relatedDate = dayjs(article.lastRelatedContentPublished.published).format("DD.MM.YYYY");
								published = relatedDate + `<span class="d-none">${article.lastRelatedContentPublished.title}</span>`;
							}
						}
						created = created === "01.01.1901" ? "" : created;
						published = published === "01.01.1901" ? "" : published;

						article.imageSpan = imageSpan;
						article.mainImage = mainImage;
						article.title = title;
						article.parsedIntro = article.pageTypeId !== "mal_blokk" ? intro : "";
						if (content === "<p>...</p>" || content === "<p>&nbsp;</p>") {
							content = "";
						}
						article.content = content;
						article.published = published;
						article.created = created;
						article.hasRightColumn = hasRightColumn;
						article.rightColumn = rightColumn;

						let contentHtml = articleDefault(article);

						if (article.pageTypeId === "mal_nyhet") {
							contentHtml = articleNews(article);
						} else if (article.pageTypeId === "mal_enhetsmal") {
							contentHtml = articleUnitpage(article);
						} else if (article.pageTypeId === "temaside") {
							contentHtml = articleThemepage(article);
						} else if (article.pageTypeId === "fokusartikkel") {
							contentHtml = articleFocusarticle(article);
						} else if (article.pageTypeId === "bti-forside") {
							contentHtml = articleBtiFrontpage(article);
						} else if (article.pageTypeId === "transportside") {
							contentHtml = articleTransportpage(article);
						} else if (article.pageTypeId === "404") {
							contentHtml = page404(article);
						}
						contentHtml = compileModules(contentHtml);
						$("#contentHtml").html(contentHtml);
						$("#contentHtml").addClass(article.pageTypeId);

						if (localStorage.getItem("access_token") !== null) {
							$("body").append(`
                        <div class="" style="position:fixed; bottom: 10px; right:10px; z-index:10000;"><div class="row"><div class="col">
                        <a class="btn btn-warning" href="${window.cmsUrl}/dashboard/nytt-innhold?id=${article.contentId}&lang=${article.language}" taria-label="Rediger denne siden (${language("NAV_OPEN_I_NEW")})" target="_blank">Rediger denne siden</a>
                        </div></div></div>
                    `);
						}

						const useCarousel = window.serverdata.configMeta.aim.useCarousel === undefined || window.serverdata.configMeta.aim.useCarousel
						if (useCarousel) {
							createCarousel();
						} else {
							createGallery();
						}
						// setResponsiveImages();
						setImageText();
						skjemaInline();

						postLoadFunctions();
					});
			});
	};

	getArticle();
}
